import { ImageLightbox, Modal } from '@orobix/orobix-fe-components'
import { useState } from 'react'

import useStyles from './SmallThumb.styles'

export interface SmallThumbProps {
  alt: string
  src: string
  largeSrc: string
  closeButtonLabel: string
  predMask?: string
}

export const SmallThumb = ({
  alt,
  src,
  largeSrc,
  closeButtonLabel,
  predMask,
}: SmallThumbProps) => {
  const classes = useStyles()
  const [modal, showModal] = useState(false)

  return (
    <>
      <button
        type="button"
        className={classes.thumb}
        onClick={() => showModal(true)}
      >
        <span className={classes.image}>
          <img alt={alt} src={src} />
        </span>
      </button>

      {modal && predMask && (
        <Modal size="xl" onCloseRequest={() => showModal(false)}>
          <div className={classes.imagesContainer}>
            <div className={classes.originalImageContainer}>
              <img className={classes.originalImage} alt={alt} src={largeSrc} />
            </div>
            <div className={classes.heatmapImageContainer}>
              <img className={classes.heatmapImage} alt={alt} src={predMask} />
            </div>
          </div>
        </Modal>
      )}

      {modal && !predMask && (
        <ImageLightbox
          closeButtonLabel={closeButtonLabel}
          onCloseRequest={() => showModal(false)}
          alt={alt}
          src={largeSrc}
          noFitImage
        />
      )}
    </>
  )
}

export default SmallThumb
